export enum HomeFeedType {
  FOLLOWING = "FOLLOWING",
  FORYOU = "FORYOU",
  HIGHLIGHTS = "HIGHLIGHTS"
}

export enum AccountFeedType {
  Collects = "COLLECTS",
  Feed = "FEED",
  Media = "MEDIA",
  Replies = "REPLIES"
}

export enum NotificationFeedType {
  All = "ALL",
  PostActions = "POST_ACTIONS",
  Comments = "COMMENTS",
  Likes = "LIKES",
  Mentions = "MENTIONS"
}

export enum GroupsFeedType {
  Managed = "MANAGED",
  Member = "MEMBER"
}

export enum Status {
  Success = "success",
  Error = "error"
}
